import React, { useEffect, useState, useCallback } from 'react';
import { Sidebar } from '../components/Sidebar';
import styles from './FrontDesk.module.css';
import { Header } from '../components/Header';
import { Bookingform } from './Bookingform';
import { Availtable } from './Availtable';
import AvailModel from './AvailModel';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FrontDesk = () => {
  const hotelId = localStorage.getItem('hotel');
  const [availData, setAvailData] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);

  /*  const handleBookingAdded = () => {
    fetchRoomsAndBookings();
  }; */

  return (
    <div className={styles.dashboard}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.maincontent}>
          <Header hotelId={hotelId} showCreateBookingBtn={true} />
          <Bookingform setAvailData={setAvailData} hotelId={hotelId} />
          <br />
          <br />
          <Availtable availData={availData} hotelId={hotelId} />
        </div>
      </div>

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default FrontDesk;
